<template>
  <div
    class="offcanvas offcanvas-fullscreen-sm-down offcanvas-end form-offcanvas"
    tabindex="-1"
    id="offcanvaInfo"
    ref="offcanvaInfo"
    data-bs-backdrop="static"
  >
    <!-- data-bs-backdrop="static" -->
    <div class="offcanvas-header border-bottom bg-white py-3">
      <h6 class="offcanvas-title fw-bold mb-0 d-flex align-items-center gap-2">
        <i class="fa-solid fa-warehouse text-theme" />
        {{ $t('Inventory Detail')  }}
      </h6>
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>

    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body p-0 bg-body-secondary"
      v-else
    >
      <div class="bg-white border-bottom d-flex overflow-x-auto topnav-offcanvas">
        <a
          class="col px-3 py-2"
          :class="tabActive == 'info'? 'active': ''"
          @click="() => {
            tabActive = 'info'
          }"
        >
          <i class="fa-solid fa-circle-info me-2" />
          {{ $t('Inventory Information') }}
        </a>
        <a
          class="border-start col px-3 py-2"
          :class="tabActive == 'lot'? 'active': ''"
          @click="async () => {
            tabActive = 'lot';
            await getLotsData();
          }"
        >
          <i class="fa-solid fa-boxes-stacked me-2" />
          {{ $t('Lots') }}
        </a>
        <a
          class="border-start col px-3 py-2"
          :class="tabActive == 'log'? 'active': ''"
          @click="async () => {
            tabActive = 'log';
            await getLogsData();
          }"
        >
          <i class="fa-solid fa-clipboard me-2" />
          {{ $t('Activity Logs') }}
        </a>
      </div>
      <div class="form-card m-3">
        <div class="px-3 py-3">
          <div class="fw-bold d-flex align-items-center flex-wrap gap-2" style="font-size: 18px;">
            {{ data.name }}
            <span
              class="badge"
              :style="$storeIndex.backgroundColorInventoryType(data.type)"
            >
              {{ $t(data.type) }}
            </span>
          </div>
          <div class="text-secondary small mt-2">
            {{ $t('Last Update') + ': ' + formatDateTime(data.updated_at) }}
          </div>
        </div>
      </div>
      <template
        v-if="tabActive == 'info'"
      >
        <div class="form-card m-3">
          <div class="form-section-header">
            <i class="fa-solid fa-circle-info" />
            <span>{{ $t('Inventory Information') }}</span>
          </div>
          <div class="px-3 pt-3">
            <div class="row g-3" style="font-size: 13px;">
              <div class="col-6 col-md-4">
                <div class="text-secondary">{{ $t('Quantity') }}</div>
                <div class="fw-medium">{{ formatNumberTwoDigit(data.quantity) + ' ' + $t(data.unit) }}</div>
              </div>
              <div class="col-6 col-md-4">
                <div class="text-secondary">{{ $t('code') }}</div>
                <div class="fw-medium">{{ data.code? data.code: '-' }}</div>
              </div>
              <div class="col-6 col-md-4">
                <div class="text-secondary">{{ $t('Category') }}</div>
                <div class="fw-medium">{{ data.category? $t(data.category): '-' }}</div>
              </div>
              <div class="col-6 col-md-4">
                <div class="text-secondary">{{ $t('Cost (MAC)') }}</div>
                <div class="fw-medium">{{ formatNumberDigit(data.cost) + '/' + $t(data.unit) }}</div>
              </div>
              <div class="col-6 col-md-4">
                <div class="text-secondary">{{ $t('Manual Cost') }}</div>
                <div class="fw-medium">
                  <template v-if="data.cost_manual !== null && data.cost_manual !== undefined && data.cost_manual !== ''">
                    {{ formatNumberDigit(data.cost_manual) + '/' + $t(data.unit) }}
                    <span class="badge bg-warning-subtle text-warning-emphasis ms-1">
                      {{ $t('Override') }}
                    </span>
                  </template>
                  <template v-else>
                    <span class="text-muted">{{ $t('Using MAC') }}</span>
                  </template>
                </div>
              </div>
              <div class="col-6 col-md-4">
                <div class="text-secondary">{{ $t('Storage') }}</div>
                <div class="fw-medium">{{ data.storage_condition? $t(data.storage_condition): '-' }}</div>
              </div>
              <div class="col-6 col-md-4">
                <div class="text-secondary">{{ $t('Create By') }}</div>
                <div class="fw-medium">{{ data.created_by }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-card m-3" v-if="data.unit_conversions.length > 0">
          <div class="form-section-header">
            <i class="fa-solid fa-scale-balanced" />
            <span>{{ $t('Unit Conversions') }}</span>
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item small" v-for="unit in data.unit_conversions">
              {{ $t(unit.name) + ' (' + formatDigit(unit.conversion_factor) + ' ' + $t(data.unit) + ')' }}
            </li>
          </ul>
        </div>
      </template>
      <template
        v-if="tabActive == 'log'"
      >
        <div class="form-card m-3">
          <div class="form-section-header">
            <i class="fa-solid fa-clipboard" />
            <span>{{ $t('Activity Logs') }}</span>
          </div>
          <div class="pb-1">
            <vue3-easy-data-table
              v-model:server-options="datatableLog.serverOptions"
              ref="datatableLog"
              :headers="datatableLog.headers($t)"
              :items="datatableLog.items"
              :loading="datatableLog.loading"
              :server-items-length="datatableLog.total"
              :theme-color="'#515151'"
              :hide-footer="false"
              :hide-rows-per-page="true"
              :empty-message="$t('No Available Data')"
              :table-min-height="null"
              :body-item-class-name="'ps-5'"
              buttons-pagination
              header-text-direction="center"
              id="table-list-feed"
              no-hover
            >
              <template #item-message="item">
                <div class="text-start">
                  {{ translateLog(item.message) }}
                </div>
              </template>
              <template #item-created_at="item">
                <div class="text-start">
                  <i class="fa-regular fa-calendar-days me-1" />
                  {{ dateDistance(item.created_at) }}
                </div>
              </template>
              <template #item-created_by="item">
                <div class="text-end">
                  <i class="fa-solid fa-user-pen me-1" />
                  {{ item.created_by }}
                </div>
              </template>
              <template #loading>
                <i class="fa-solid fa-spinner fa-spin fa-2xl" />
              </template>
            </vue3-easy-data-table>
          </div>
        </div>
      </template>
      <template
        v-if="tabActive == 'lot'"
      >
        <div class="form-card m-3">
          <div class="form-section-header">
            <i class="fa-solid fa-boxes-stacked" />
            <span>{{ $t('Lots') }}</span>
          </div>
          <div class="p-0">
            <vue3-easy-data-table
              v-model:server-options="datatableLot.serverOptions"
              ref="datatableLot"
              :headers="datatableLot.headers($t)"
              :items="datatableLot.items"
              :loading="datatableLot.loading"
              :server-items-length="datatableLot.total"
              :theme-color="'#515151'"
              :hide-footer="false"
              :hide-rows-per-page="true"
              :empty-message="$t('No Available Data')"
              :table-min-height="null"
              :body-item-class-name="bodyItemClassNameFunction"
              buttons-pagination
              table-class-name='customize-table-in-offcanvas'
              header-text-direction="center"
            >
              <template #item-quantity="item">
                {{ formatDigit(item.quantity) }}
              </template>
              <template #item-remaining_quantity="item">
                {{ formatDigit(item.remaining_quantity) }}
              </template>
              <template #item-cost="item">
                {{ formatNumberDigit(item.cost) }}
              </template>
              <template #item-received_date="item">
                {{ formatDate(item.received_date) }}
              </template>
              <template #item-expiry_date="item">
                {{ item.expiry_date? formatDate(item.expiry_date): '-' }}
              </template>
              <template #item-created_at="item">
                {{ formatDateTime(item.created_at) }}
              </template>
              <!-- <template #item-action="item">
                <div class="icon-link custom-actions">
                  <popper
                    :placement="'top'"
                    :hover="true"
                    :arrow="true"
                    :disableClickAway="true"
                    class="popper-default border-0 m-0"
                  >
                    <button
                      type="button"
                      data-bs-toggle="popover"
                      data-bs-placement="top"
                      data-bs-title="Custom popover"
                      data-bs-content="This popover is themed via CSS variables."
                      class="btn btn-outline-primary btn-sm btn-icon"
                      @click="() => {
                      }"
                    >
                      <i class="fa-solid fa-square-pen" />
                    </button>
                    <template #content>
                      <div>{{ $t('Edit') }}</div>
                    </template>
                  </popper>
                  <popper
                    :placement="'top'"
                    :hover="true"
                    :arrow="true"
                    :disableClickAway="true"
                    class="popper-default border-0 m-0"
                  >
                    <button
                      type="button"
                      data-bs-toggle="popover"
                      data-bs-placement="top"
                      data-bs-title="Custom popover"
                      data-bs-content="This popover is themed via CSS variables."
                      class="btn btn-outline-primary btn-sm btn-icon"
                      @click="handleDeleteLot(item.id)"
                    >
                      <i class="fa-solid fa-trash-can" />
                    </button>
                    <template #content>
                      <div>{{ $t('Delete') }}</div>
                    </template>
                  </popper>
                </div>
              </template> -->
              <template #loading>
                <i class="fa-solid fa-spinner fa-spin fa-2xl" />
              </template>
            </vue3-easy-data-table>
          </div>
        </div>
      </template>
    </div>
    <div
      class="bg-light border-top justify-content-center modal-footer py-2"
      v-if="!loading"
    >
      <div class="btn-group dropdown">
        <button
          type="button"
          class="btn btn-sm btn-theme dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          @mouseenter="isHovered = true"
          @mouseleave="isHovered = false"
        >
          <i class="fa-solid fa-ellipsis me-1" :class="isHovered? 'fa-fade': ''" />
          {{ $t('More Action') }}
        </button>
        <ul class="dropdown-menu">
          <li>
            <a
              class="dropdown-item"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              @click="() => {
                $parent.form.open = true;
                $parent.form.viewOnly = false;
                $parent.form.inventoryId = inventoryId;
                $parent.form.type = 'EDIT';
              }"
            >
              <i class="fa-solid fa-square-pen" />
              {{ $t('Edit') }}
            </a>
          </li>
          <li>
            <a
              class="dropdown-item"
              @click="handleDelete()"
            >
              <i class="fa-solid fa-trash-can" />
              {{ $t('Delete') }}
            </a>
          </li>
        </ul>
      </div>
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light me-2 ms-2"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script lang="js">
import Vue3EasyDataTable from 'vue3-easy-data-table';
import { Inventories, InventoryLots } from '@/services/endpoint/inventories.service';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import Ladda from '@/plugins/Ladda.vue';
import moment from "moment";
import numeral from 'numeral';
import { distance } from '@/store/date-fns'
import FieldsLogs from "./assets/template/datatable/FieldsLogs";
import FieldsLots from "./assets/template/datatable/FieldsLots";
import Popper from "vue3-popper";

export default {
  props: {
    inventoryId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tabActive: 'info',
      datatableLog: {
        loading: false,
        headers: FieldsLogs,
        items: [],
        total: 0,
        serverOptions: {
          page: 1,
          rowsPerPage: 10
        },
        params: {
          limit: 10,
          page: 1,
          search: ''
        }
      },
      datatableLot: {
        loading: false,
        headers: FieldsLots,
        items: [],
        total: 0,
        serverOptions: {
          page: 1,
          rowsPerPage: 10
        },
        params: {
          limit: 10,
          page: 1,
          search: ''
        }
      },
      isHovered: false,
      loadingCard: true,
      loading: true,
      data: {
        name: '',
        code: '',
        quantity: 0,
        cost: 0,
        unit_id: '1',
      },
      tabCards: [
        {
          id: 1,
          name: 'Activity Logs',
          disabled: false
        },
        {
          id: 2,
          name: 'Unusable',
          disabled: false
        }
      ],
      selectTabCard: 1
    }
  },
  components: {
    Vue3EasyDataTable,
    PlaceholderContent,
    Ladda,
    Popper
  },
  methods: {
    translateLog(message) {
      if (!message) return message;

      // Whole phrases emitted by silver-spoon-api when writing `inventory_logs`.
      // Sorted longest-first so a phrase always wins over any of its substrings.
      const phrases = [
        // StockAdjustmentController
        'Reversal Cancel: Decrease stock previously added by doc',
        'Reversal Cancel: Restock items previously deducted by doc',
        'Stock deducted successfully from lot',
        'Stock added successfully.',
        'Auto-created new lot',
        // StockDeductionHelper (sale order deduct / restock)
        'Stock restored from cancelled sale order',
        'Stock deducted by sale order',
        'from sale order item',
        'ingredient qty',
        'Stock restored',
        'units',
        // GoodsReceiptController — open paren only: the doc no. is interpolated
        // before the closing paren, so the match must not include ')'.
        'Reverted stock (Bill Cancellation',
        'Updated Moving Average Cost (MAC)',
        'Received item into stock',
        'to branch',
        // InventoryController
        'with opening stock of',
        'Created new inventory',
        'Updated inventory',
        'changed storage condition',
        'changed tax status',
        'changed category',
        'changed name',
        'remove image',
        'add image',
        // InventoryProductionBatchController
        'Production Output',
        'Stock Deduction',
        'Quantity',
        'Batch',
        // InventoryLotController / ProcessInventoryLotNumber
        'delete lot',
        'create lot',
      ].sort((a, b) => b.length - a.length);

      // Units of measure — matched on word boundaries so we never corrupt a
      // substring (e.g. the "gram" in "kilogram", or the "can" in "Cancellation").
      const units = [
        'kilogram', 'gram', 'milliliter', 'liter', 'piece',
        'bottle', 'can', 'pack', 'carton',
      ];

      // Short connector words live under the `_InventoryLog` module so we don't
      // pollute the flat namespace with generic words like "from"/"to".
      const connectors = {
        from: this.$t('_InventoryLog.from'),
        to: this.$t('_InventoryLog.to'),
        full: this.$t('__InventoryLog.full'),
        partial: this.$t('__InventoryLog.partial'),
        order: this.$t('__InventoryLog.order'),
        qty: this.$t('Qty'),
      };

      let result = message;
      phrases.forEach(phrase => {
        result = result.replaceAll(phrase, this.$t(phrase));
      });
      units.forEach(unit => {
        result = result.replace(new RegExp(`\\b${unit}\\b`, 'g'), this.$t(unit));
      });
      Object.entries(connectors).forEach(([word, translated]) => {
        result = result.replace(new RegExp(`\\b${word}\\b`, 'gi'), translated);
      });
      return result;
    },
    bodyItemClassNameFunction(column, rowNumber) {
      let className = 'align-top py-1 px-2 border-0';
      const columnCenter = ['received_date', 'expiry_date', 'created_at'];
      const columnEnd = ['quantity', 'remaining_quantity', 'cost', 'created_by'];
      if (columnCenter.includes(column)) {
        className += ' text-center';
      }
      if (columnEnd.includes(column)) {
        className += ' text-end';
      }
      return className;
    },
    formatDigit(value) {
      if ((value < 0.01) && value != 0) {
        return numeral(value).format("0,0.0000");
      }
      return numeral(value).format("0,0.00");
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    async getInfoData() {
      this.loading = true;
      await Inventories.getInfo(this.inventoryId).then(res => {
        this.data = res.data.data;
        this.loading = false;
      }).catch(err => {
			  throw err;
      });
    },
    async getLogsData() {
      this.datatableLog.loading = true;
      var queryString = '?' + $.param(this.datatableLog.params);
      await Inventories.getLogs(this.inventoryId, queryString).then(res => {
        this.datatableLog.items = res.data.data;
        this.datatableLog.total = res.data.meta.total;
      }).catch(err => {
      });

      this.datatableLog.loading = false;
      return;
    },
    async getLotsData() {
      this.datatableLot.loading = true;
      var queryString = '?' + $.param(this.datatableLot.params);
      await Inventories.getLots(this.inventoryId, queryString).then(res => {
        this.datatableLot.items = res.data.data;
        this.datatableLot.total = res.data.meta.total;
      }).catch(err => {
      });

      this.datatableLot.loading = false;
      return;
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY');
    },
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    dateDistance(value) {
      return distance(value);
    },
    async handleDelete() {
      try {
        let self = this;
        let title = this.$t("Delete Inventory") + '?';
        let html = this.$t("You will not be able to undo this action.");
        let confirmButtonText =
          '<i class="fas fa-check-circle me-1"></i>' + this.$t("Confirm");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          // text: "You will not be able to undo this action.",
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary me-2",
            cancelButton: "btn btn-danger",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return Inventories.delete(self.inventoryId)
              .then((response) => {
                self.$parent.fetchData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Delete Product Success!'));
                $(self.$refs.offcanvaInfo).offcanvas('hide');
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
    async handleEditLot() {
      try {
        let self = this;
        let title = this.$t("Delete Lot") + '?';
        let html = this.$t("Deleting this lot may affect past cost calculations");
        let confirmButtonText =
          '<i class="fas fa-check-circle me-1"></i>' + this.$t("Confirm");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          // text: "You will not be able to undo this action.",
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary me-2",
            cancelButton: "btn btn-danger",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return Inventories.delete(self.inventoryId)
              .then((response) => {
                self.$parent.fetchData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Delete Product Success!'));
                $(self.$refs.offcanvaInfo).offcanvas('hide');
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
    async handleDeleteLot() {
      try {
        let self = this;
        let title = this.$t("Delete Lot") + '?';
        let html = this.$t("Deleting this lot may affect past cost calculations");
        let confirmButtonText =
          '<i class="fas fa-check-circle me-1"></i>' + this.$t("Confirm");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          // text: "You will not be able to undo this action.",
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary me-2",
            cancelButton: "btn btn-danger",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return InventoryLots.delete(self.inventoryId)
              .then((response) => {
                self.$parent.fetchData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Delete Product Success!'));
                $(self.$refs.offcanvaInfo).offcanvas('hide');
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
  },
  async mounted() {
    $(this.$refs.offcanvaInfo).offcanvas('show');

    $(this.$refs.offcanvaInfo).on('shown.bs.offcanvas',async () => {
      try {
        await this.getInfoData();
        // await this.getLogsData();
        // await this.getLotsData();
      } catch (err) {
      }
    });

    $(this.$refs.offcanvaInfo).on('hidden.bs.offcanvas', () => {
      this.$parent.formInfo.open = false;
    });
  },
  computed: {

  },
  watch: {
    "datatableLog.serverOptions" (nval, oval) {
      delete this.datatableLog.params.sort;
      this.datatableLog.params.page = nval.page;
      this.datatableLog.params.limit = nval.rowsPerPage;
      if (nval.sortBy && nval.sortType) this.datatableLog.params.sort = nval.sortBy + "|" + nval.sortType;
      this.getLogsData();
    },
    "datatableLot.serverOptions" (nval, oval) {
      delete this.datatableLot.params.sort;
      this.datatableLot.params.page = nval.page;
      this.datatableLot.params.limit = nval.rowsPerPage;
      if (nval.sortBy && nval.sortType) this.datatableLot.params.sort = nval.sortBy + "|" + nval.sortType;
      this.getLotsData();
    }
  }
}
</script>
